import { useContext } from 'react';
import { ThemeContext } from 'src/theme/ThemeProvider';
import { getStoreDeviceSession } from './deviceIdentity';
import { useDeviceSettingsApplied, WebDeviceSetting } from './deviceSettings';

/**
 * Live-applies the managed light / dark mode: ThemeProvider reads localStorage.appTheme only at
 * mount, and its setter is reachable only through ThemeContext, so this sits inside ThemeProvider
 * (App.tsx) and hands it the stored value whenever an apply changed it.
 */
export default function DeviceSettingsBridge(): null {
  const setThemeName = useContext(ThemeContext);
  useDeviceSettingsApplied([WebDeviceSetting.themeMode], () => {
    if (!getStoreDeviceSession()) return;
    let raw: string | null = null;
    try {
      raw = localStorage.getItem('appTheme');
    } catch {
      return;
    }
    setThemeName(raw || 'PureLightTheme');
    // The setter stores what it is given; a value restored to "never chosen" stays absent.
    if (!raw) {
      try {
        localStorage.removeItem('appTheme');
      } catch {
        /* ignore */
      }
    }
  });
  return null;
}
